import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Grid } from "@mui/material";
import { Button } from "@gpstrackit/gtc-react-controls";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import Preferences from "Core/containers/Preferences";

import { getNextPreviousIds } from "../../../../views/media/redux/slice";
import { EVENTS_PREFERENCES_KEY } from "../../../../../main";

const NextPreviousButtons = ({ rowId, deviceId, loading }) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [preferences, setPreferences] = useState();
  const [request, setRequest] = useState(null);

  const getEvent = (action) => {
    if (!preferences) return;
    setRequest(request);
    const {
      dateRange,
      openSearch,
      starred,
      entities,
      events,
      mediaType,
      hasNotes,
    } = preferences?.filters;

    const filters = {
      dateRange,
      openSearch,
      starred,
      entities,
      events,
      mediaDeleted: false,
      mediaType: mediaType,
      hasNotes,
    };

    const variables = {
      filters,
      rowId: rowId,
      deviceId: deviceId,
      action: action,
      navigate,
    };

    dispatch(getNextPreviousIds(variables));
  };

  return (
    <Grid>
      <Preferences
        preferencesKey={EVENTS_PREFERENCES_KEY}
        onInitialPreferences={(data) => {
          setPreferences(data);
        }}
      >
        {preferences && (
          <>
            <Button
              isDisabled={loading}
              onClick={() => getEvent("next")}
              style={{ marginRight: "10px" }}
            >
              {messages["videoDetail_nexPreviousButton_previous"]}
            </Button>
            <Button isDisabled={loading} onClick={() => getEvent("previous")}>
              {messages["videoDetail_nexPreviousButton_next"]}
            </Button>
          </>
        )}
      </Preferences>
    </Grid>
  );
};

export default NextPreviousButtons;
